import React from 'react'
import { useInView } from 'react-intersection-observer'

import Slider from '../slider'

import hexagonShape from '../../icons/hexagon-shape.svg'

const SliderKeyFigures = ({data, isOffer = false}) => {
  const { ref, inView} = useInView({ threshold: 0.3, triggerOnce: true})
  const chapo = (data.chapo) ? (data.chapo.chapo) ? data.chapo.chapo : data.chapo : null
  let checkIfAllKeyFigures = true
  let options = '{ "slidesPerView": 1, "breakpoints": { "768": { "slidesPerView": 3, "slidesPerGroup": 3 }, "1280": { "slidesPerView": 4, "slidesPerGroup": 4}} }'

  if (isOffer) {
    options = '{ "slidesPerView": 1, "breakpoints": { "768": { "slidesPerView": 3, "slidesPerGroup": 3 }, "1280": { "slidesPerView": 3, "slidesPerGroup": 3}} }'
  }

  data.items.forEach(item => {
    item = item.fields ? item.fields : item
    
    if(item.altImage !== undefined) {
      checkIfAllKeyFigures = false
    }
  })

  return (
    <div ref={ref} className={`${isOffer ? 'key-figures-offer has-full-bg' : ''} ${inView ? 'has-anim' : ''}`}>
      { (data.title || chapo) &&
        <div className="row mb-6 md:mb-10 scroll-anim-el">
          <div className={`col-12 ${!isOffer ? 'text-center lg-col-8 mx-auto' : 'text-center lg:text-left'}`}>
            { data.title &&
              <h2 className={`title title-slice ${isOffer ? 'slider-cards-title' : ''} ${ chapo ? 'mb-3 md:mb-6' : '' }`}>{data.title}</h2>
            }

            { chapo &&
              <p className={`paragraph ${isOffer ? 'slider-cards-title' : ''}`}>{chapo}</p>
            }
          </div>
        </div>
      }
      <div className="row">
        <div className={`col-12 ${isOffer ? 'lg-col-9' : 'lg-col-10' } mx-auto`}>
          <div className="key-figures">
            { checkIfAllKeyFigures
              ? 
              <Slider 
                options = {options}
                name="key-figures"
                nbItems={data.items.length}
                className={`slider-centered scroll-anim-el scroll-anim-el--${data.title || chapo ? 2 : 1}`}
                navCentered={isOffer ? false : true} 
                hasPagination={true}>
                { data.items.map((item, i) => { 
                  const keyFigure = (item.fields) ? item.fields : item
                  const text = (keyFigure.text.text) ? keyFigure.text.text : keyFigure.text
                  let color = ''
                
                  let figure = keyFigure.title.split(' ')
                  const unit = figure.length > 1 ? figure[figure.length -1] : ''
                  
                  if (figure.length > 1) {
                    figure.pop()
                  }
                  figure = figure.join(' ')
                  
                  switch((i + 1) % 4) {
                    case 1:
                      color = 'turquoise'
                      break
                    case 2:
                      color = 'orange'
                      break
                    case 3:
                      color = 'night'
                      break
                    case 0:
                      color = 'purple'
                      break
                    default:
                      color = 'purple'
                  }

                  return(
                    <div className="key-figure center" key={i}>
                      <svg className={`key-figure__shape icon-${color}`} width="200" height="200">
                        <use xlinkHref={hexagonShape.url} />
                      </svg>
                      <div className="p-8">
                        <p className="key-figure__figure font-alternate">{figure}{unit && <span>{unit}</span> }</p>
                        <p className="mt-1">{text}</p>
                      </div>
                    </div>
                  )
                }) }
              </Slider>
              : 'Slider - Format de données incorrect. Il faut uniquement des chiffres clés si le type chiffre clés est sélectionné.'
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default SliderKeyFigures